import React from "react";
import "./SplashScreen.css";

/* ── LLM Pipeline Loader ──────────────────────────────────────
   Input node → flowing tokens → Processor → output node
   Pure CSS animation, no libraries.
   ──────────────────────────────────────────────────────────── */
export default function SplashScreen() {
  return (
    <div className="splash-screen">
      <div className="splash-content">
        {/* Pipeline animation */}
        <div className="pipeline" aria-hidden="true">
          {/* Input node */}
          <div className="pl-node pl-node--input">
            <span className="pl-node__dot" />
          </div>

          {/* Track 1 — input → processor */}
          <div className="pl-track">
            <div className="pl-track__line" />
            <span className="pl-token pl-token--1" />
            <span className="pl-token pl-token--2" />
            <span className="pl-token pl-token--3" />
          </div>

          {/* Processor */}
          <div className="pl-node pl-node--proc">
            <span className="pl-proc__ring" />
            <span className="pl-proc__core" />
          </div>

          {/* Track 2 — processor → output */}
          <div className="pl-track">
            <div className="pl-track__line" />
            <span className="pl-token pl-token--4" />
            <span className="pl-token pl-token--5" />
            <span className="pl-token pl-token--6" />
          </div>

          {/* Output node */}
          <div className="pl-node pl-node--output">
            <span className="pl-node__dot pl-node__dot--out" />
          </div>
        </div>

        <p className="splash-caption">
          Initializing AI systems<span className="splash-ellipsis">...</span>
        </p>
      </div>
    </div>
  );
}
